import React, { useState } from "react";

import andres from "../img/4.jpg";
import aldo from "../img/1.jpg";
import diego from "../img/5.jpg";
import pamela from "../img/2.jpg";
import Katherina from "../img/3.jpg";
import logo from "../img/logo.png";

import "../App.css";

function QuienesSomos() {

  const equipo = [
    {
      numero: "01",
      nombre: "Andrés Tapia Torres",
      cargo: "Director(a)",
      imagen: andres,
    },
    {
      numero: "02",
      nombre: "Aldo Alberto Bustamante",
      cargo: "Inspector General",
      imagen: aldo,
    },
    {
      numero: "03",
      nombre: "Diego Pozo Cabello",
      cargo: "U.T.P.",
      imagen: diego,
    },
    {
      numero: "04",
      nombre: "Pamela Contreras Pérez",
      cargo: "Convivencia Escolar",
      imagen: pamela,
    },
    {
      numero: "05",
      nombre: "Katherina Paz Cifuentes",
      cargo: "Coordinadora P.I.E.",
      imagen: Katherina,
    },
  ];

  const [imagenGrande, setImagenGrande] = useState(null);

  return (

   // <section className="equipo-directivo-container">
       <section id="QuienesSomos" className="equipo-directivo-container">

      {/* Fondo decorativo */}
      <div className="bg-shape-left"></div>
      <div className="bg-shape-right"></div>

      {/* Logo */}
      <div className="logo-escuela">
        <img src={logo} alt="Logo Escuela" />
      </div>

      {/* Título */}
      <div className="titulo-principal">

        <h1>
          Equipo Directivo <span>2026</span>
        </h1>

        <div className="linea-decorativa">
          <span></span>
          <div className="punto"></div>
          <span></span>
        </div>

      </div>

      {/* Director */}
      <div className="director-container">

        <div className="card-directivo principal">

          <div className="numero-card">
            01
          </div>

          <img
            src={equipo[0].imagen}
            alt={equipo[0].nombre}
            onDoubleClick={() => setImagenGrande(equipo[0].imagen)}
          />

          <div className="nombre-box">
            <h3>{equipo[0].nombre}</h3>
          </div>

          <div className="cargo-box">
            <div className="linea-roja"></div>
            <p>{equipo[0].cargo}</p>
          </div>

        </div>

      </div>

      {/* Línea horizontal */}
      <div className="linea-horizontal"></div>

      {/* Equipo inferior */}
      <div className="equipo-grid">

        {equipo.slice(1).map((miembro, index) => (

          <div className="item-equipo" key={index}>

            <div className="linea-vertical"></div>

            <div className="card-directivo">

              <div className="numero-card">
                {miembro.numero}
              </div>

              <img
                src={miembro.imagen}
                alt={miembro.nombre}
                onDoubleClick={() => setImagenGrande(miembro.imagen)}
              />

              <div className="nombre-box">
                <h3>{miembro.nombre}</h3>
              </div>

              <div className="cargo-box">
                <div className="linea-roja"></div>
                <p>{miembro.cargo}</p>
              </div>

            </div>

          </div>

        ))}

      </div>

      {/* Modal Imagen Grande */}
      {imagenGrande && (

        <div
          className="modal-imagen"
          onClick={() => setImagenGrande(null)}
        >

          <img
            src={imagenGrande}
            alt="Imagen ampliada"
          />

        </div>

      )}

    </section>

  );
}

export default QuienesSomos;